// Logout flow logger - appends logs to sessionStorage for debugging

class LogoutLogger {
    constructor() {
        this.logs = [];
        this.sessionKey = 'logoutFlowLogs';
    }

    log(message, data = null) {
        const timestamp = new Date().toISOString();
        const logEntry = {
            timestamp,
            message,
            data: data ? JSON.stringify(data) : null
        };

        this.logs.push(logEntry);

        // Also log to console
        console.log(`[${timestamp}] ${message}`, data || '');

        // Save to sessionStorage (survives until browser close)
        try {
            const existing = sessionStorage.getItem(this.sessionKey);
            const allLogs = existing ? JSON.parse(existing) : [];
            allLogs.push(logEntry);
            sessionStorage.setItem(this.sessionKey, JSON.stringify(allLogs));
        } catch (e) {
            console.error('Failed to save log:', e);
        }
    }

    clear() {
        this.logs = [];
        try {
            sessionStorage.removeItem(this.sessionKey);
        } catch (e) {
            console.error('Failed to clear logs:', e);
        }
    }

    getLogs() {
        try {
            const logs = sessionStorage.getItem(this.sessionKey);
            return logs ? JSON.parse(logs) : [];
        } catch (e) {
            console.error('Failed to get logs:', e);
            return [];
        }
    }

    download() {
        const logs = this.getLogs();
        const content = logs.map(log =>
            `[${log.timestamp}] ${log.message}${log.data ? '\n  Data: ' + log.data : ''}`
        ).join('\n\n');

        const blob = new Blob([content], { type: 'text/plain' });
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `logout-flow-${Date.now()}.log`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
    }

    print() {
        const logs = this.getLogs();
        console.group('=== LOGOUT FLOW LOGS ===');
        logs.forEach(log => {
            console.log(`[${log.timestamp}] ${log.message}`);
            if (log.data) {
                console.log('  Data:', JSON.parse(log.data));
            }
        });
        console.groupEnd();
        return logs;
    }
}

// Create singleton instance
const logoutLogger = new LogoutLogger();

// Expose to window for debugging in console
if (typeof window !== 'undefined') {
    window.logoutLogger = logoutLogger;
}

export default logoutLogger;
